import { Page } from "../../Components/Page/Page.component";
import { MoviesTable } from "./Movies";

export const MoviesPage = () => {
  return (
    <Page title="Movies">
      <MoviesTable />
    </Page>
  );
};
